import React from 'react'
import { PostPoll } from '../PostPoll'
import { PostPollCard } from '../../../generated/api/post-row'

interface PostPollsProps {
  postId: string
  polls: PostPollCard[]
  disabled?: boolean
}

export const PostPolls = ({
  postId,
  polls,
  disabled,
}: PostPollsProps): JSX.Element | null => {
  if (polls.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-4">
      {polls.map((poll) => (
        <PostPoll
          key={poll.id}
          postId={postId}
          poll={poll}
          disabled={disabled}
        />
      ))}
    </div>
  )
}
